import * as validators from 'vuelidate/lib/validators';

export const isValidDate = (value) => value instanceof Date && !Number.isNaN(value);

export const { required, minLength } = validators;
